var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _g, _rect2, _rect3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _polygon, _path28, _path29, _polygon2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 500 500",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M407.82,395.69c-0.2,0.41-0.44,0.64-0.69,0.66c-0.08,0-0.14,0.02-0.23,0.02 c-7.21-0.16-19.89-37.29-38.16-35.16c-0.2,0.02-0.39,0.05-0.59,0.06c0,0,17.37-8.27,26.13-3.74 C407.86,364.57,409.98,391.18,407.82,395.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2d2dc",
    d: "M407.82,395.69c-0.2,0.41-0.44,0.64-0.69,0.66c-0.08,0-0.14,0.02-0.23,0.02 c-7.21-0.16-19.89-37.29-38.16-35.16c0,0,20.15-7.99,29.63,8.36C404.38,379.95,406.82,389.85,407.82,395.69z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M408.25,418.8c-0.01,0-0.02,0-0.03,0c-0.24-0.01-0.43-0.23-0.41-0.47c0.04-0.58,3.21-55.02-25.89-59.02 c-0.24-0.03-0.03-1.24,0-1.48c0.03-0.24,1.14,0,1.39,0.04c29.92,4.11,25.42,59.92,25.38,60.51 C408.68,418.62,408.48,418.8,408.25,418.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M455.62,373.96c0,0-0.02,0-0.06-0.02c-18.46-2.8-31.29,34.62-38.56,35.1c-0.13,0.02-0.23,0.02-0.33,0 c-0.14-0.02-0.27-0.08-0.38-0.2c-2.63-2.66-0.92-31.27,13.26-38.6C438.05,365.85,454.68,373.51,455.62,373.96z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2d2dc",
    d: "M455.56,373.95c-18.46-2.8-31.29,34.62-38.56,35.1c-0.13,0.02-0.23,0.02-0.33,0 c-0.14-0.02-0.27-0.08-0.38-0.2c1.25-6.47,3.54-19.64,11.18-29.02C437.76,367.21,454.35,373.52,455.56,373.95z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M415.56,431.5c-0.23,0-0.43-0.18-0.44-0.42c-0.04-0.59-3.47-55.85,26.45-59.97 c0.26-0.04,0.84,0.04,0.87,0.28c0.03,0.24,0.02,0.69-0.22,0.73c-29.11,4-26.25,58.32-26.22,58.9 c0.02,0.24-0.17,0.46-0.41,0.47C415.58,431.5,415.57,431.5,415.56,431.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M409.45,371.38v0.05c-0.02,0.13-0.03,0.17-0.03,0.17s-0.08-0.06-0.23-0.19 c-1.49-1.31-9.91-9.44-13.96-28.24c-5.63-26-15.68-31.96-16.31-32.3c-0.02-0.02-0.03-0.02-0.03-0.02l-0.58-0.3 c0.2-0.05,0.39-0.08,0.58-0.11c14.04-2.6,24.67,4.22,28.72,20.53C412.09,349.07,409.75,369.07,409.45,371.38z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2d2dc",
    d: "M409.18,371.41c-1.49-1.31-9.91-9.44-13.96-28.24c-5.63-26-15.68-31.96-16.31-32.3 c0.94,0.16,19.57,3.88,24.66,25.36C407.4,352.46,408.75,365.61,409.18,371.41z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M411.34,428.84L411.34,428.84c-0.25,0-0.44-0.2-0.44-0.44l0.01-0.32c0.33-10.78,3.06-98.36-22.84-113.59 c-0.21-0.12,0.75-1.19,0.98-1.11c26.22,9.53,23.29,97.04,22.75,114.72l-0.01,0.29C411.78,428.64,411.59,428.84,411.34,428.84 z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M445.89,322.81l-0.13,0.06l-0.48,0.23c0,0-10.49,5.47-16.31,32.33c-4.36,20.15-13.74,28.05-14.2,28.39 c-0.02-0.06-0.05-0.28-0.08-0.64c0,0,0,0,0-0.02c-0.45-3.75-2.39-22.7,1.88-39.95c4.1-16.49,14.95-23.28,29.22-20.42H445.89z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2d2dc",
    d: "M445.8,322.81c0,0,0,0.02-0.03,0.06l-0.48,0.23c0,0-10.49,5.47-16.31,32.33 c-4.36,20.15-13.74,28.05-14.2,28.39c-0.02-0.06-0.05-0.28-0.08-0.64c0,0,0,0,0-0.02c2.94-26.21,7.6-39.2,11.8-47.25 C431.71,325.98,445.8,322.81,445.8,322.81z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M412.65,429.88c-0.24,0-0.44-0.2-0.44-0.44c-0.18-28.89,1.19-94.03,22.99-103.61 c0.23-0.1,1.19-1.31,1.28-1.09c0.1,0.23,0.16,1.63-0.07,1.73c-21.32,9.37-23.5,74.24-23.32,102.96 C413.1,429.68,412.9,429.88,412.65,429.88C412.65,429.88,412.65,429.88,412.65,429.88z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M395.29,417.84l0.27,3.17l2.46,27.75c0.12,1.51,1.37,2.68,2.89,2.69l23.57,0.21 c1.53,0.01,2.79-1.13,2.94-2.64l2.65-24.96l0-0.05l0.62-5.86L395.29,417.84z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbe7ee",
    d: "M395.57,421.01l2.46,27.75c0.12,1.51,1.37,2.68,2.89,2.69l11.22,0.1c-10.19-4.06-12.68-13.11-10.61-20.05 c2.25-7.51,26.02-7.47,28.55-7.45c0.13,0,0.22,0,0.22,0l-0.22-0.05l-22.54-4.74L395.57,421.01z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M394.24,423.83l37.41,0.33c0.64,0.01,1.16-0.51,1.17-1.15l0.03-3.69c0.01-0.64-0.51-1.16-1.15-1.17 l-37.41-0.33c-0.64-0.01-1.16,0.51-1.17,1.15l-0.03,3.69C393.09,423.3,393.6,423.83,394.24,423.83z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 210.47,
    height: 210.47,
    x: 161.68,
    y: 172.23,
    fill: "#d2e1f7",
    transform: "rotate(180 266.91 277.467)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M117.66,196.88h173.39c2.44,0,4.43-1.98,4.43-4.43V80.32c0-2.44-1.98-4.43-4.43-4.43H117.66 c-2.44,0-4.43,1.98-4.43,4.43v112.14C113.23,194.9,115.22,196.88,117.66,196.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M113.43,93.42h182.24V79.74c0-2.44-1.98-4.43-4.43-4.43H117.85c-2.44,0-4.43,1.98-4.43,4.43V93.42z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.31,
    cy: 84.37,
    r: 2.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.79,
    cy: 84.37,
    r: 2.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.26,
    cy: 84.37,
    r: 2.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.87,
    height: 3.1,
    x: 137.19,
    y: 106.54,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.54,
    height: 3.1,
    x: 186.23,
    y: 106.54,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 127.01,
    y: 106.54,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.55,
    height: 3.1,
    x: 241.58,
    y: 106.54,
    fill: "#505ea3",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.33,
    height: 3.1,
    x: 206.26,
    y: 106.54,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#505ea3",
    points: "188.9 165.11 186.23 165.11 137.19 165.11 137.19 168.21 186.23 168.21 188.9 168.21 199.76 168.21 199.76 165.11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 127.01,
    y: 165.11,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.23,
    height: 3.1,
    x: 241.58,
    y: 165.11,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.33,
    height: 3.1,
    x: 206.26,
    y: 165.11,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.97,
    height: 3.1,
    x: 137.19,
    y: 116.3,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.56,
    height: 3.1,
    x: 150.08,
    y: 116.3,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 127.01,
    y: 116.3,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.31,
    height: 3.1,
    x: 206.26,
    y: 116.3,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.97,
    height: 3.1,
    x: 137.19,
    y: 174.87,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.97,
    height: 3.1,
    x: 209.84,
    y: 174.87,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.56,
    height: 3.1,
    x: 150.08,
    y: 174.87,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 127.01,
    y: 174.87,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.89,
    height: 3.1,
    x: 226.68,
    y: 174.87,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 27.29,
    height: 3.1,
    x: 137.19,
    y: 126.06,
    fill: "#505ea3",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.29,
    height: 3.1,
    x: 167.78,
    y: 126.06,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 127.01,
    y: 126.06,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.15,
    height: 3.1,
    x: 187.14,
    y: 126.06,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.81,
    height: 3.1,
    x: 232.76,
    y: 126.06,
    fill: "#d64e12",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 72.33,
    height: 3.1,
    x: 137.19,
    y: 135.83,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 127.01,
    y: 135.83,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.39,
    height: 3.1,
    x: 213.31,
    y: 135.83,
    fill: "#505ea3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 37.13,
    height: 3.1,
    x: 137.19,
    y: 145.59,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 127.01,
    y: 145.59,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.78,
    height: 3.1,
    x: 195.92,
    y: 145.59,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.54,
    height: 3.1,
    x: 272.03,
    y: 145.59,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.54,
    height: 3.1,
    x: 179.25,
    y: 145.59,
    fill: "#505ea3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 18.67,
    height: 3.1,
    x: 137.19,
    y: 155.35,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.67,
    height: 3.1,
    x: 174.84,
    y: 155.35,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 127.01,
    y: 155.35,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.37,
    height: 3.1,
    x: 200.47,
    y: 155.35,
    fill: "#505ea3",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.36,
    height: 3.1,
    x: 255.21,
    y: 155.35,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.54,
    height: 3.1,
    x: 160.93,
    y: 155.35,
    fill: "#505ea3",
    opacity: 0.5
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25.96,
    height: 25.96,
    x: 104.65,
    y: 242.74,
    fill: "#d2e1f7",
    transform: "rotate(180 117.627 255.72)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 71.49,
    height: 71.49,
    x: 394.99,
    y: 151.07,
    fill: "#d2e1f7",
    transform: "rotate(180 430.736 186.813)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce9789",
    d: "M266.86,199.33c0,0,5.69,11.57,6.07,11.31c0.4-0.25,13.22-11.44,13.22-11.44l-4.26-16.84l-3.8,0l-9.75,3.1 L266.86,199.33z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce9789",
    d: "M250.81,204.43c-13.78,0.55-38.33,71.2-28.74,72.56C235,285.96,273.11,208,250.81,204.43z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M341.45,452.39L341.45,452.39c1-0.09,1.73-0.98,1.63-1.98l-10.19-103.83c-0.1-0.99-0.98-1.71-1.97-1.62l0,0 c-1,0.09-1.73,0.98-1.63,1.98l10.19,103.83C339.58,451.75,340.46,452.48,341.45,452.39z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M306.51,452.39L306.51,452.39c1-0.09,1.73-0.98,1.63-1.98l-10.19-103.83c-0.1-0.99-0.98-1.71-1.97-1.62l0,0 c-1,0.09-1.73,0.98-1.63,1.98l10.19,103.83C304.64,451.75,305.52,452.48,306.51,452.39z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M221.47,452.39L221.47,452.39c-1-0.09-1.73-0.98-1.63-1.98l10.19-103.83c0.1-0.99,0.98-1.71,1.97-1.62h0 c1,0.09,1.73,0.98,1.63,1.98l-10.19,103.83C223.34,451.75,222.46,452.48,221.47,452.39z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M266.37,452.39L266.37,452.39c-1-0.09-1.73-0.98-1.63-1.98l10.19-103.83c0.1-0.99,0.98-1.71,1.97-1.62l0,0 c1,0.09,1.73,0.98,1.63,1.98l-10.19,103.83C268.24,451.75,267.36,452.48,266.37,452.39z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M219.77,347.84c0,5.36,4.35,9.71,9.71,9.71h107.05c2.67,0,5.11-1.08,6.87-2.84 c1.75-1.76,2.84-4.2,2.84-6.87c0-0.9-0.12-1.78-0.37-2.6c-1.12-4.09-4.88-7.09-9.34-7.09H229.48c-2.67,0-5.11,1.08-6.87,2.84 c-1.17,1.17-2.03,2.62-2.47,4.25C219.89,346.06,219.77,346.94,219.77,347.84z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M220.14,345.24c1.12,4.09,4.88,7.09,9.34,7.09h107.05c2.67,0,5.11-1.08,6.87-2.84 c1.17-1.17,2.03-2.62,2.47-4.25c-1.12-4.09-4.88-7.09-9.34-7.09H229.48c-2.67,0-5.11,1.08-6.87,2.84 C221.44,342.15,220.58,343.6,220.14,345.24z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M348.81,283.04c0,29.01-8.77,52.52-40.39,52.52c-30.07,0-40.39-23.51-40.39-52.52s-2.53-78.68,40.39-78.68 C352.74,204.36,348.81,254.04,348.81,283.04z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M342.81,283.04c0,29.01-8.77,52.52-40.39,52.52c-30.07,0-40.39-23.51-40.39-52.52s-2.53-78.68,40.39-78.68 C346.74,204.36,342.81,254.04,342.81,283.04z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce9789",
    d: "M281.74,316.4c3.88,16.87-13.88,12.68-28.41,13.11c-23.04-0.13-66.17,10.58-71.49,2.7 c-13.08-21.32,87.23-35.47,92.67-30.03C277.01,304.75,279.7,310.93,281.74,316.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce9789",
    d: "M183.78,322.61c16.9-11.91,14.84,87.38,10.16,109.95c-4.68,22.57-9.3-11.67-12.29-47.82 C178.67,348.59,177.13,327.29,183.78,322.61z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ce9789",
    points: "199.55 427.15 198 438.86 183.38 438.76 183.19 426.76"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#d64e12",
    d: "M183.44,438.96c0,0-2.05,5.03-10.74,11.65c-8.69,6.62-10.97,5.19-11.17,7.65 c-0.2,2.47,36.11,0.32,36.11,0.32l0.39-19.67C198.02,438.91,183.44,438.43,183.44,438.96z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M181.37,429.54l19.74,0.13c0,0,6.91-55.65,4.33-81.2c0,0,31.67-2.39,55.98-5.09 c2.4-0.26,4.72-0.53,6.94-0.81c2.92-0.36,5.66-0.71,8.12-1.07c23.23-3.36,35.81-4.13,30.78-31.74c0,0-7.42-3.72-15.63-7.8 c-0.9-0.45-1.82-0.9-2.74-1.37h-0.01c-8.93-4.46-17.89-8.9-18.52-9.16c-1.29-0.51-23.09,9.82-23.09,9.82s-59.63,6.96-68.14,20.89 C170.61,336.08,181.37,429.54,181.37,429.54z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ce9789",
    points: "249.42 424.45 249.36 435.54 267.13 435.67 267.09 425.89"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#d64e12",
    d: "M249.19,435.38c-0.23,4.38-4.8,19.36-4.9,23.16c28.25,0.72,27.45,6.4,22.89-23.07L249.19,435.38z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M247.26,427.44l21.73,0.17c5.16-36.39,5.11-77.07,5.89-78.88c0.19-0.45,1.36-0.74,3.32-0.99h0.01 c5.9-0.73,18.87-1.01,33.56-3.92c19.62-3.87,11.37-29.41,11.37-29.41l-15.21-5.76l-13.39-8.02c0,0-49.61,11.97-53.47,26.94 C236.49,345.27,247.26,427.44,247.26,427.44z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4d8",
    d: "M277.7,347.46l0.49,0.27h0.01c5.9-0.73,18.87-1.01,33.56-3.92c19.62-3.87,11.37-29.41,11.37-29.41 l-15.21-5.76c0.75,1.15,8.79,14,3.15,23.14C305.19,341.37,287.38,347.27,277.7,347.46z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#d64e12",
    d: "M251.91,201.63l-0.12,17.36l-0.26,34.25c0,0-0.27,0.44-0.75,1.23c-0.12,0.19-0.25,0.41-0.4,0.64 c-0.44,0.7-0.99,1.59-1.62,2.63l-7.76-5.22l-14.77-9.94c3.78-9.75,7.69-19.17,10.46-24.31 C244.04,204.59,251.91,201.63,251.91,201.63z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4d8",
    d: "M251.78,218.99l-0.26,34.25c0,0-0.27,0.44-0.75,1.23c-0.12,0.19-0.25,0.4-0.4,0.64 c-0.44,0.7-0.99,1.59-1.62,2.63l-7.76-5.22c0.27-9.65,0.12-13.94,0-21.44c-0.14-7.94,2.45-18.22,2.45-18.22 S247.64,215.93,251.78,218.99z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#d64e12",
    d: "M266.86,198.39c-2.6,0.18-7.42,0.84-9.57,1.3c-7.12,1.53-11.79,5.07-14.17,13.79 c-3.1,11.36,4.13,87.75,4.13,87.75c51.49-5.42,70.07,15.1,74.71,13.94c4.65-1.16,3.48-3.1,0.39-22.07 c-3.1-18.97-6.74-70.34-9.29-81.3c-2.3-9.9-13.79-12.07-20.46-12.48c-2.86-0.18-6.45-0.32-6.45-0.32S269.06,210.36,266.86,198.39 z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4d8",
    d: "M298.94,226.33c0,0,10.31,28.88,11.47,32.36c1.16,3.48,0.52,6.32-4.65,8.52s8.13,6.19,8.39,5.42 s17.42-15.74,16.39-16.65C329.51,255.07,298.94,226.33,298.94,226.33z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce9789",
    d: "M303.53,207.3c-9.19,10.29,24.51,77.06,32.16,71.11C351.12,275.36,321.61,193.76,303.53,207.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce9789",
    d: "M333.62,241.4c0,0,11.1,27.87,6.32,34.07c-4.77,6.19-50.58,10.07-50.58,10.07l-1.94-12.9 c0,0,31.81-7.81,31.91-8.29c0.1-0.48-7.74-14.23-7.74-14.23L333.62,241.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8a29a",
    d: "M265.07,166.42l11.46-4.92l9.34,7.93c0,0-0.02,2.51-0.22,5.71c0.86,0.67,1.79,1.48,1.77,1.76 c-0.04,0.48-2.71,7.79-3.02,7.89c-1.39,5.54-7.84,10.79-11.99,10.72c-6.03-0.09-6.49-6.66-7.41-11.82 C264.06,178.54,265.07,166.42,265.07,166.42z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M286.76,182.54c1.36-2.72,2.31-5.76,2.72-11.84c0.27-3.99-0.59-8.81-3.66-10.6 c-3.07-1.79-5.88-1.13-8.11-3.26c-2.23-2.12-4.7-2.46-7.28-1.44s-3.13,4.5-5.63,4.56c-2.5,0.06-6.7,6.39-0.17,9.18 c0.67,0.29,2.17-1.09,2.17-1.09s5.17,1.75,8.94,1.44c3.77-0.31,5.67-0.94,5.67-0.94l0.53,8.41c0,0,3-2.75,4.05-0.82 c0.64,1.18-2,9.42-2.7,11.49C282.83,188.97,286.06,183.93,286.76,182.54z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce9789",
    d: "M340.89,272.32c-0.03,2.2-1.39,4.2-3.3,5.3c-14.94,8.6-81.06,9.68-79.2,5.04 C258.29,279.1,341.11,255.74,340.89,272.32z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce9789",
    d: "M267.89,278.65l0.68-0.58l-1.81-0.94l-0.01,0l-3.21-1.48c-0.83-0.37-1.72-0.55-2.63-0.49l-3.82,1.2 c0,0-0.58,1.09,1.69,0.98c0.59-0.03,1.42,0.43,2.08,0.85l-2.22,0.41l-4.96,1.04c-1.37,0.35,0.08,6.72,2.72,7.12l1.39,0.3 c1.96,0.12,3.45,0.58,5.3-0.08l4.88-2.21L267.89,278.65z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#d64e12",
    d: "M311.11,251.85c0,0,0,0,0-0.01c-4.7-8.57-10.61-19.92-12.17-25.5c0,0-10.32-21.22-2.65-24.72 c1.03-0.47,3.19-1.22,4.25-0.96c7.86,1.91,16.06,7.58,21.58,15.58c3.69,5.32,8.6,15.07,12.67,25.27c0,0,0.01,0.01,0.01,0.03 L311.11,251.85z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M371.29,452.39L371.29,452.39c0.99-0.09,1.72-0.97,1.63-1.97l-14.44-154.69c-0.09-0.99-0.97-1.72-1.97-1.63 l0,0c-0.99,0.09-1.72,0.97-1.63,1.97l14.44,154.69C369.41,451.75,370.29,452.48,371.29,452.39z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M91.34,452.39L91.34,452.39c-0.99-0.09-1.72-0.97-1.63-1.97l14.44-154.69c0.09-0.99,0.97-1.72,1.97-1.63h0 c0.99,0.09,1.72,0.97,1.63,1.97L93.3,450.76C93.21,451.75,92.33,452.48,91.34,452.39z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M92,296.33h278.62c3.14,0,5.68-2.54,5.68-5.68l0,0c0-3.14-2.54-5.68-5.68-5.68H92 c-3.14,0-5.68,2.54-5.68,5.68l0,0C86.32,293.79,88.87,296.33,92,296.33z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M264.68,284.98h-53.04v-3.3h49.73C263.2,281.67,264.68,283.15,264.68,284.98L264.68,284.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9fbff4",
    d: "M169.45,284.98h68.05l-6.53-41.83c-0.19-1.21-1.23-2.11-2.46-2.11H165.5c-1.53,0-2.7,1.36-2.46,2.87 L169.45,284.98z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M50.14,229.41h173.39c2.44,0,4.43-1.98,4.43-4.43V112.85c0-2.44-1.98-4.43-4.43-4.43H50.14 c-2.44,0-4.43,1.98-4.43,4.43v112.14C45.71,227.43,47.7,229.41,50.14,229.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M45.91,125.95h182.24v-13.68c0-2.44-1.98-4.43-4.43-4.43H50.33c-2.44,0-4.43,1.98-4.43,4.43V125.95z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.79,
    cy: 116.89,
    r: 2.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.27,
    cy: 116.89,
    r: 2.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.74,
    cy: 116.89,
    r: 2.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.87,
    height: 3.1,
    x: 69.67,
    y: 139.07,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.54,
    height: 3.1,
    x: 118.71,
    y: 139.07,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 59.49,
    y: 139.07,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.55,
    height: 3.1,
    x: 174.06,
    y: 139.07,
    fill: "#505ea3",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.33,
    height: 3.1,
    x: 138.74,
    y: 139.07,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#505ea3",
    points: "121.38 197.63 118.71 197.63 69.67 197.63 69.67 200.73 118.71 200.73 121.38 200.73 132.24 200.73 132.24 197.63"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 59.49,
    y: 197.63,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.23,
    height: 3.1,
    x: 174.06,
    y: 197.63,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.33,
    height: 3.1,
    x: 138.74,
    y: 197.63,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.97,
    height: 3.1,
    x: 69.67,
    y: 148.83,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.56,
    height: 3.1,
    x: 82.56,
    y: 148.83,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 59.49,
    y: 148.83,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.31,
    height: 3.1,
    x: 138.74,
    y: 148.83,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.97,
    height: 3.1,
    x: 69.67,
    y: 207.39,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.97,
    height: 3.1,
    x: 142.32,
    y: 207.39,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.56,
    height: 3.1,
    x: 82.56,
    y: 207.39,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 59.49,
    y: 207.39,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.89,
    height: 3.1,
    x: 159.16,
    y: 207.39,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 27.29,
    height: 3.1,
    x: 69.67,
    y: 158.59,
    fill: "#505ea3",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.29,
    height: 3.1,
    x: 100.26,
    y: 158.59,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 59.49,
    y: 158.59,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.15,
    height: 3.1,
    x: 119.62,
    y: 158.59,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.81,
    height: 3.1,
    x: 165.24,
    y: 158.59,
    fill: "#d64e12",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 72.33,
    height: 3.1,
    x: 69.67,
    y: 168.35,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 59.49,
    y: 168.35,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.39,
    height: 3.1,
    x: 145.79,
    y: 168.35,
    fill: "#505ea3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 37.13,
    height: 3.1,
    x: 69.67,
    y: 178.11,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 59.49,
    y: 178.11,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.78,
    height: 3.1,
    x: 128.4,
    y: 178.11,
    fill: "#505ea3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.54,
    height: 3.1,
    x: 204.51,
    y: 178.11,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.54,
    height: 3.1,
    x: 111.73,
    y: 178.11,
    fill: "#505ea3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 18.67,
    height: 3.1,
    x: 69.67,
    y: 187.87,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.67,
    height: 3.1,
    x: 107.32,
    y: 187.87,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.71,
    height: 3.1,
    x: 59.49,
    y: 187.87,
    fill: "#505ea3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.37,
    height: 3.1,
    x: 132.95,
    y: 187.87,
    fill: "#505ea3",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.36,
    height: 3.1,
    x: 187.69,
    y: 187.87,
    fill: "#d64e12",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.54,
    height: 3.1,
    x: 93.41,
    y: 187.87,
    fill: "#505ea3",
    opacity: 0.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9fbff4",
    d: "M327.56,205.88h107.03c1.51,0,2.73-1.22,2.73-2.73v-69.22c0-1.51-1.22-2.73-2.73-2.73H327.56 c-1.51,0-2.73,1.22-2.73,2.73v69.22C324.83,204.65,326.05,205.88,327.56,205.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03254e",
    d: "M324.83,142.37h112.49v-8.45c0-1.51-1.22-2.73-2.73-2.73H327.56c-1.51,0-2.73,1.22-2.73,2.73V142.37z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.83,
    cy: 136.78,
    r: 1.61,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.1,
    cy: 136.78,
    r: 1.61,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.37,
    cy: 136.78,
    r: 1.61,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M390.64,192.56c-1.69,0-3.83-0.95-6.24-2.81c-3.26-2.51-6.71-6.42-9.72-10.99 c-3.01-4.58-5.23-9.29-6.25-13.28c-1.08-4.22-0.67-7.2,1.15-8.4c1.82-1.2,4.72-0.39,8.17,2.27c3.26,2.51,6.71,6.42,9.72,10.99 c5.65,8.59,9.1,19.04,5.1,21.68C392.02,192.38,391.37,192.56,390.64,192.56z M371.54,157.91c-0.47,0-0.88,0.11-1.21,0.32 c-1.27,0.84-1.48,3.36-0.57,6.91c0.98,3.84,3.14,8.41,6.06,12.86c2.93,4.45,6.27,8.24,9.41,10.66 c2.91,2.24,5.31,3.05,6.58,2.21c2.48-1.63,0.84-10.16-5.49-19.78c-2.93-4.45-6.27-8.24-9.41-10.66 C374.76,158.78,372.88,157.91,371.54,157.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M371.51,192.56c-0.73,0-1.38-0.18-1.93-0.54c-4-2.63-0.55-13.09,5.1-21.68 c3.01-4.58,6.46-8.48,9.72-10.99c3.45-2.66,6.35-3.47,8.17-2.27c1.82,1.2,2.23,4.18,1.15,8.4c-1.02,3.99-3.24,8.7-6.25,13.28 c-3.01,4.58-6.46,8.48-9.72,10.99C375.34,191.61,373.2,192.56,371.51,192.56z M390.61,157.91c-1.34,0-3.22,0.87-5.37,2.53 c-3.14,2.42-6.48,6.21-9.41,10.66c-6.33,9.62-7.97,18.14-5.49,19.78c1.27,0.84,3.67,0.03,6.58-2.21 c3.14-2.42,6.48-6.21,9.41-10.66c2.93-4.45,5.08-9.02,6.06-12.86c0.91-3.56,0.7-6.08-0.57-6.91 C391.49,158.01,391.08,157.91,390.61,157.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505ea3",
    d: "M381.08,182.21c-10.28,0-20.91-2.86-20.91-7.65s10.63-7.65,20.91-7.65c10.28,0,20.91,2.86,20.91,7.65 S391.36,182.21,381.08,182.21z M381.08,168.27c-11.52,0-19.54,3.31-19.54,6.28s8.03,6.28,19.54,6.28s19.54-3.31,19.54-6.28 S392.59,168.27,381.08,168.27z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.59,
    cy: 174.55,
    r: 3.18,
    fill: "#505ea3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 29.39,
    height: 2.07,
    x: 329.31,
    y: 67.35,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.07,
    height: 2.07,
    x: 362.17,
    y: 67.35,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.49,
    height: 2.07,
    x: 322.49,
    y: 67.35,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.43,
    height: 2.07,
    x: 399.25,
    y: 67.35,
    fill: "#d2e1f7",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.99,
    height: 2.07,
    x: 375.59,
    y: 67.35,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d2e1f7",
    points: "363.96 106.59 362.17 106.59 329.31 106.59 329.31 108.66 362.17 108.66 363.96 108.66 371.23 108.66 371.23 106.59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.49,
    height: 2.07,
    x: 322.49,
    y: 106.59,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.85,
    height: 2.07,
    x: 399.25,
    y: 106.59,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.99,
    height: 2.07,
    x: 375.59,
    y: 106.59,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.01,
    height: 2.07,
    x: 329.31,
    y: 73.89,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.87,
    height: 2.07,
    x: 337.95,
    y: 73.89,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.49,
    height: 2.07,
    x: 322.49,
    y: 73.89,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.45,
    height: 2.07,
    x: 375.59,
    y: 73.89,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.01,
    height: 2.07,
    x: 329.31,
    y: 113.13,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.01,
    height: 2.07,
    x: 377.99,
    y: 113.13,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.87,
    height: 2.07,
    x: 337.95,
    y: 113.13,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.49,
    height: 2.07,
    x: 322.49,
    y: 113.13,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.78,
    height: 2.07,
    x: 389.27,
    y: 113.13,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 18.28,
    height: 2.07,
    x: 329.31,
    y: 80.43,
    fill: "#d2e1f7",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 2.07,
    x: 349.8,
    y: 80.43,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.49,
    height: 2.07,
    x: 322.49,
    y: 80.43,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.57,
    height: 2.07,
    x: 362.78,
    y: 80.43,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.7,
    height: 2.07,
    x: 393.34,
    y: 80.43,
    fill: "#d2e1f7",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 48.46,
    height: 2.07,
    x: 329.31,
    y: 86.97,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.49,
    height: 2.07,
    x: 322.49,
    y: 86.97,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.77,
    height: 2.07,
    x: 380.31,
    y: 86.97,
    fill: "#d2e1f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 24.87,
    height: 2.07,
    x: 329.31,
    y: 93.51,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.49,
    height: 2.07,
    x: 322.49,
    y: 93.51,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.42,
    height: 2.07,
    x: 368.66,
    y: 93.51,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.39,
    height: 2.07,
    x: 419.65,
    y: 93.51,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.39,
    height: 2.07,
    x: 357.49,
    y: 93.51,
    fill: "#d2e1f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 12.51,
    height: 2.07,
    x: 329.31,
    y: 100.05,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.51,
    height: 2.07,
    x: 354.54,
    y: 100.05,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.49,
    height: 2.07,
    x: 322.49,
    y: 100.05,
    fill: "#d2e1f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.4,
    height: 2.07,
    x: 371.71,
    y: 100.05,
    fill: "#d2e1f7",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.66,
    height: 2.07,
    x: 408.38,
    y: 100.05,
    fill: "#d2e1f7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.39,
    height: 2.07,
    x: 345.22,
    y: 100.05,
    fill: "#d2e1f7",
    opacity: 0.5
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 27.82,
    height: 24.78,
    x: 204,
    y: 70.48,
    fill: "#03254e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M213.51,87.94l-5.09-3.55v-2.1l5.09-3.57v2.35l-3.17,2.25l3.17,2.27V87.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M215.16,89.53l4.06-13.32h1.47l-4.06,13.32H215.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M222.3,87.94V85.6l3.17-2.27l-3.17-2.25v-2.35l5.09,3.57v2.1L222.3,87.94z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 27.82,
    height: 24.78,
    x: 41.52,
    y: 262.69,
    fill: "#03254e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.03,280.15l-5.09-3.55v-2.1l5.09-3.57v2.35l-3.17,2.25l3.17,2.27V280.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.68,281.74l4.06-13.32h1.47l-4.06,13.32H52.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.82,280.15v-2.34l3.17-2.27l-3.17-2.25v-2.35l5.09,3.57v2.1L59.82,280.15z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 27.82,
    height: 24.78,
    x: 410.7,
    y: 251.46,
    fill: "#03254e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M420.22,268.92l-5.09-3.55v-2.1l5.09-3.57v2.35l-3.17,2.25l3.17,2.27V268.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M421.87,270.51l4.06-13.32h1.47l-4.06,13.32H421.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M429.01,268.92v-2.34l3.17-2.27l-3.17-2.25v-2.35l5.09,3.57v2.1L429.01,268.92z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#d64e12",
    d: "M308.67,252.92c0.21-0.1,0.47-0.21,0.77-0.34L308.67,252.92z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.8b19a1722cd73cd5cee9005aecc0ece6.svg";
export { ForwardRef as ReactComponent };